import React, { Component } from 'react';
import { Link } from 'react-router-dom';

class Login extends Component {
    constructor(props){
        super(props);
   
        this.state = {
            email: '',
            psw: '',
            errores: ''
        }
       this.changInput = this.changInput.bind(this);
       
    }
    entrar(e){
        e.preventDefault();
        var formData = new FormData();
        formData.append('correo', this.state.email);
        formData.append('pw', this.state.psw);
        formData.append('Ad', 'select');
        fetch('httpS://ebenlovequickpc.com/API/admin.php',{
            method: 'POST',
            body: formData
        }).then((response => response.json()))
        .then((json) => {
             console.log(json);
             if(json.status == 'Fail'){
                this.setState({
                    errores: json.message
                })
             }else{
                localStorage.setItem('TOKEN',json.token);
                setTimeout(()=>{
                    window.location.href = '/';
                }, 1000);
             }
             
        }).catch(()=>{
            this.setState({
                errores: 'Error para entrar'
            })
        });
    }
    changInput(e){
        switch(e.target.name){
            case 'email':
                this.setState({
                    email: e.target.value
                });
            break;
            case 'psw':
                this.setState({
                    psw: e.target.value
                });
            break;
            default:
            break;
        }
    }

  render() {
    return (
        <div className="w3-display-container w3-animate-opacity w3-text-white">
        <br />
            <h1 className='w3-text-red'>{this.state.errores}</h1>
            <div>
                    <div id="id01">
                        <div className="w3-modal-content w3-round-large w3-card-4 w3-animate-zoom" style={{maxWidth:'600px'}}>
                            <div className="w3-center" ><br />
                                <img src="https://www.w3schools.com/w3css/img_avatar2.png" alt="Avatar" style={{width:'30%'}} className="w3-circle w3-margin-top" />
                            </div>
                            <form className="w3-container" onSubmit={this.entrar.bind(this)}>
                                <div className="w3-section">
                                    <input className="w3-input w3-border w3-margin-bottom" type="text" placeholder="Email" name="email" required onChange={this.changInput} />
                                    <input className="w3-input w3-border" type="password" placeholder="Password" name="psw" required onChange={this.changInput} />
                                    <button className="w3-button w3-block w3-green w3-section w3-padding">Entrar</button>
                                </div>
                            </form>
                        </div>
                    </div>
             </div>
        </div>
    );
  }
}

export default Login;


// WEBPACK FOOTER //
// ./src/Login/Login.js